// 设置文件
import setting from '@/setting.js'
// 静态的，非接口获取的菜单
import operate from '@/menu/modules/operate'
import center from '@/menu/modules/center'
import matchlist from '@/menu/modules/matchlist'
import shed from '@/menu/modules/shed'

export default {
  namespaced: true,
  state: {
    // 顶栏菜单
    header: [],
    // 侧栏菜单
    aside: [],
    auths: [],
    // 侧边栏收缩
    url: [],
    asideCollapse: setting.menu.asideCollapse,
    cunttername: '',
    cooperate: "",
    // 动态菜单
    menuList: [],
    //公棚赛事权限
    roundStatus: '0',
    // 全部的侧边菜单
    asideList: []
  },
  getters: {
    usertokens(state) {
      return state.url || {}
    },
    getcunterName(state) {
      return state.cunttername || {}
    },
    getcooperate(state) {
      return state.cooperate || {}
    }
  },
  actions: {
    /**
     * 设置侧边栏展开或者收缩
     * @param {Object} state vuex state
     * @param {Boolean} collapse is collapse
     */
    asideCollapseSet({ state, dispatch }, collapse) {
      return new Promise(async resolve => {
        // store 赋值
        state.asideCollapse = collapse
        // 持久化
        await dispatch('d2admin/db/set', {
          dbName: 'sys',
          path: 'menu.asideCollapse',
          value: state.asideCollapse,
          user: true
        }, { root: true })
        // end
        resolve()
      })
    },
    /**
     * 切换侧边栏展开和收缩
     * @param {Object} state vuex state
     */
    asideCollapseToggle({ state, dispatch }) {
      return new Promise(async resolve => {
        // store 赋值
        state.asideCollapse = !state.asideCollapse
        // 持久化
        await dispatch('d2admin/db/set', {
          dbName: 'sys',
          path: 'menu.asideCollapse',
          value: state.asideCollapse,
          user: true
        }, { root: true })
        // end
        resolve()
      })
    },
    /**
     * 从持久化数据读取侧边栏展开或者收缩
     * @param {Object} state vuex state
     */
    asideCollapseLoad({ state, dispatch }) {
      return new Promise(async resolve => {
        // store 赋值
        state.asideCollapse = await dispatch('d2admin/db/get', {
          dbName: 'sys',
          path: 'menu.asideCollapse',
          defaultValue: setting.menu.asideCollapse,
          user: true
        }, { root: true })
        // end
        resolve()
      })
    }
  },
  mutations: {
    /**
     * @description 设置顶栏菜单
     * @param {Object} state vuex state
     * @param {Array} menu menu setting
     */
    headerSet(state, menu) {
      // store 赋值
      state.header = menu
    },
    cunttername(state, name) {
      console.log(name)
      state.cunttername = name
    },
    /**
     * @description 设置侧边栏菜单
     * @param {Object} state vuex state
     * @param {Array} menu menu setting
     */
    asideSet(state, menu) {
      // store 赋值
      state.aside = menu
    },
    authSet(state, auths) {
      // store 赋值

      state.auths = auths
    },
    authurl(state, url) {
      // store 赋值

      state.url = url
    },
    roundStatus(state, roundStatus) {
      // store 赋值
      console.log('roundStatus', roundStatus)
      state.roundStatus = roundStatus
    },
    autcooperate(state, url) {
      // store 赋值

      state.cooperate = url
    },
    // 动态菜单
    menuListSet(state, menuList) {
      state.menuList = menuList
      // 根据menuList提取headerList
      let headerList = menuList.map(item => {
        return {
          menuId: item.menuId,
          title: item.name,
          path: item.url,
          auth_token: item.perms
        }
      })
      state.header = headerList
      // 根据menuList提取asideList
      let asideList = menuList.map(item => {
        if (item.list && item.list.length > 0) {
          return {
            menuId: item.menuId,
            title: item.name,
            path: item.url,
            icon: item.icon,
            auth_token: item.perms,
            children: item.list.map(childItem => {
              if (childItem.list && childItem.list.length > 0) {
                return {
                  menuId: childItem.menuId,
                  title: childItem.name,
                  path: childItem.url,
                  icon: childItem.icon,
                  auth_token: childItem.perms,
                  children: childItem.list.map(secoldChildItem => {
                    return {
                      menuId: secoldChildItem.menuId,
                      title: secoldChildItem.name,
                      path: secoldChildItem.url,
                      icon: secoldChildItem.icon,
                      auth_token: secoldChildItem.perms,
                    }
                  })
                }
              } else {
                return {
                  menuId: childItem.menuId,
                  title: childItem.name,
                  path: childItem.url,
                  icon: childItem.icon,
                  auth_token: childItem.perms
                }
              }
            })
          }
        } else {
          return {
            menuId: item.menuId,
            title: item.name,
            path: item.url,
            icon: item.icon,
            auth_token: item.perms
          }
        }
      })
      // 加入非接口获取的，静态的菜单
      state.asideList = [operate, center, matchlist, shed, ...asideList]
      // 也存到session
      localStorage.setItem("d2admin-asideList", JSON.stringify(state.asideList))
    }
  }
}
